const store = {
  _intent: undefined,
  _intentData: {},
  _recentBrokers: [],
  _isReturningUser: false,
  _deviceType: 'web',
  _isMobileDevice: false,

  set intent(data) {
    this._intent = data;
  },

  get intent() {
    return this._intent;
  },

  set intentData(data) {
    this._intentData = { ...this._intentData, ...data };
  },

  get intentData() {
    return this._intentData;
  },

  set recentBrokers(data) {
    this._recentBrokers = data;
  },

  get recentBrokers() {
    return this._recentBrokers;
  },

  set isReturningUser(data) {
    this._isReturningUser = data;
  },

  get isReturningUser() {
    return this._isReturningUser;
  },

  set deviceType(data) {
    this._deviceType = data;
  },

  get deviceType() {
    return this._deviceType;
  },

  set isMobileDevice(data) {
    this._isMobileDevice = data;
  },

  get isMobileDevice() {
    return this._isMobileDevice;
  },
};

export default store;



// WEBPACK FOOTER //
// ./utils/store.js